import { GUEST_FRAME_PROTOCOL_VERSION, type FrameRuntimeErrorPhase } from '@doss/guest-frame'
import * as Sentry from '@sentry/react'
import config from '~/common/config/config'

let guestFrameSentryInitialized = false

const initializeGuestFrameSentry = (): void => {
  if (guestFrameSentryInitialized) {
    return
  }
  guestFrameSentryInitialized = true
  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.isProduction ? 'production' : 'staging',
    release: __DOSS_WEB_RELEASE__,
    enabled: config.isStaging || config.isProduction,
    sendDefaultPii: false,
    autoSessionTracking: false,
    sendClientReports: false,
    defaultIntegrations: false,
    integrations: [],
  })
}

export type GuestFrameFailurePhase = FrameRuntimeErrorPhase | 'boot_timeout' | 'protocol_mismatch'

export const captureGuestFrameFailure = ({
  phase,
  runtimeBuildSha,
}: {
  phase: GuestFrameFailurePhase
  runtimeBuildSha?: string
}): void => {
  initializeGuestFrameSentry()
  Sentry.withScope((scope) => {
    scope.setTag('guest_frame.phase', phase)
    scope.setFingerprint(['guest-frame', phase])
    scope.setContext('guest_frame', {
      // LEGACY_CJS_MIGRATE: ENG-601 — Attribute the resolved ESM version while retaining failure telemetry.
      protocolVersion: GUEST_FRAME_PROTOCOL_VERSION,
      runtimeBuildSha: runtimeBuildSha ?? 'unknown',
    })
    Sentry.captureException(new Error(`Guest frame failure: ${phase}`))
  })
}
